import { db } from '../firebase';
import { collection, query, where, getDocs } from 'firebase/firestore';

export interface CompanySubscriptions {
  id?: string;
  companyId: string;
  features: string[];
  isActive: boolean;
  createdAt?: any;
  createdBy?: string;
  endDate?: any;
  maxAdmins?: number;
  maxUsers?: number;
  price?: number;
  subscriptionId?: string;
}

export async function getCompanySubscriptions(companyIds: string[]): Promise<CompanySubscriptions[]> {
  try {
    console.log('Getting subscription for companyId:', companyIds);
    
    const subscriptionsRef = collection(db, 'companySubscriptions');
    const q = query(
      subscriptionsRef,
      where('companyId', 'in', companyIds),
      where('isActive', '==', true)
    );
    const querySnapshot = await getDocs(q);

    if (querySnapshot.empty) {
      console.log('No active subscription found for companyId:', companyIds);
      return [];
    }
    // Return all active subscriptions for the given companyIds
    const subscriptions = querySnapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    }) as CompanySubscriptions);
    console.log('Found subscriptions:', subscriptions);
    return subscriptions;
    
  } catch (error) {
    console.error('Error getting company subscription:', error);
    return [];
  }
}
